import { AfterViewInit, Component, inject, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Cls_MobiDocumentViewer, Cls_MobiFile, FileType } from "../models";
import { ToastrService } from "ngx-toastr";
import { GlobalService } from "../services";

@Component({
  selector: "mobi-office-lib-document-viewer",
  templateUrl: "./document-viewer.component.html",
  styleUrl: "./document-viewer.component.scss",
  standalone: false,
})
export class DocumentViewerComponent implements AfterViewInit {
  private readonly toastr = inject(ToastrService);
  public readonly globalService = inject(GlobalService);
  private readonly data: Cls_MobiDocumentViewer = inject(MAT_DIALOG_DATA);

  constructor() {
    this.documentViewerModal = this.data;
    this.selectedDocumentIndex = this.data.selectedFileIndex;
  }

  ngAfterViewInit(): void {
    let currentZoom = 1;
    const minZoom = 0.7;
    const maxZoom = 3;
    const stepSize = 0.1;
    const headerContainer = document.getElementById("header-container") as any;
    headerContainer.addEventListener("wheel", function (event: WheelEvent) {
      if (event.ctrlKey) {
        event.preventDefault();
      }
    });

    const container = document.getElementById("image-container") as any;
    container.addEventListener("wheel", function (event: WheelEvent) {
      if (event.ctrlKey) {
        event.preventDefault();
        const direction = event.deltaY > 0 ? -1 : 1;
        zoomImage(direction, event);
      }
    });

    function zoomImage(direction: number, event: WheelEvent) {
      const newZoom = currentZoom + direction * stepSize;
      if (newZoom < minZoom || newZoom > maxZoom) {
        return;
      }

      currentZoom = newZoom;
      const image = document.querySelector("#image-container img") as any;

      const rect = image.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const originX = (offsetX / rect.width) * 100;
      const originY = (offsetY / rect.height) * 100;

      image.style.transformOrigin = `${originX}% ${originY}%`;
      image.style.transform = `scale(${currentZoom})`;
    }
  }

  selectedDocumentIndex: number = 0;
  documentViewerModal = new Cls_MobiDocumentViewer();
  FILE_TYPE = FileType;

  get selectedDocument(): Cls_MobiFile {
    return this.documentViewerModal.FileList[this.selectedDocumentIndex];
  }

  onNext(index: number) {
    const tempIndex = index + this.selectedDocumentIndex;
    if (tempIndex < 0 || tempIndex > this.documentViewerModal.FileList.length - 1) {
      this.toastr.info("Document not found", "Info");
      return;
    }
    this.selectedDocumentIndex = tempIndex;
  }

  onCopyLink() {
    this.toastr.success("Link copied", "Success");
  }

  onDownload() {
    const isUrl = this.selectedDocument.fileUrl.startsWith("http");

    if (isUrl) {
      this.globalService.openDocumentInNewTab(this.selectedDocument.fileUrl);
      return;
    }

    // Create a link element
    const link = document.createElement("a");
    link.href = this.selectedDocument.fileUrl;
    link.download = "image.png";

    // Programmatically click the link to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link element
    document.body.removeChild(link);
  }
}
